<template>
    <div class="update-qwilr-block">
      <h3>Update Block</h3>
      <div class="form-group mb-4">
        <label for="qwilr-block-id" class="form-label">Qwilr Block ID</label>
        <input
          type="text"
          id="qwilr-block-id"
          class="form-control"
          v-model="qwilrBlockId"
          disabled
      />
      </div>
      <div class="form-group mb-4">
        <label for="qwilr-block-title" class="form-label">Qwilr Block Title</label>
        <input
          type="text"
          id="qwilr-block-title"
          class="form-control"
          v-model="qwilrBlockTitle"
          placeholder="Enter block title"
      />
      </div>
      <div class="form-group mb-4">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          placeholder="Enter block description"
          rows="4"
        ></textarea>
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="updateBlock" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Update Block
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrDefinitionElement } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'

  export default{
    name:"UpdateQwilrDefinitionBlock",
    props:{
        block:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            description:'',
            qwilrBlockId:'',
            qwilrBlockTitle:'',
            qwilrBlockType:'',
            isBusy:false
        }
    },
    methods:{
        async updateBlock(){
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.validateFields()) {
                this.isBusy = false;
                return;
              }

              const toast = useToast();
              const payload = { id:this.block.id, elementType:this.qwilrBlockType, description:this.description, title:this.qwilrBlockTitle};
          
              await UpdateQwilrDefinitionElement(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Block updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('blockUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update block : ${errorMessage}`, {timeout: 2000,});
                      })
            }, 500);

        },
        validateFields() {
          const toast = useToast();

          if (this.qwilrBlockTitle.trim() === '') {
            toast.error('Block title is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    },
    created() {
        this.qwilrBlockId = this.block.qwilrElementId
        this.description=this.block.description
        this.qwilrBlockTitle=this.block.title
        this.qwilrBlockType=this.block.elementType
    }
  }
 </script>
  
  <style scoped>
  .update-qwilr-block {
    width: 600px; /* Double the size */
    height: 500px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  